import { useTranslation } from 'react-i18next';
import { TRAVEL_STYLES, TRAVEL_STYLE_LABELS, type TravelStyleSlug } from '../../constants/slugs';

export interface StyleChip {
    slug: TravelStyleSlug;
    labelKey: string;
    icon: JSX.Element;
}

/* Refined icons definitions */
const STYLE_ICONS: Record<TravelStyleSlug, JSX.Element> = {
    [TRAVEL_STYLES.RELAX]: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v2" /><path d="m4.93 4.93 1.41 1.41" /><path d="M20 12h2" /><path d="m19.07 4.93-1.41 1.41" /><path d="M15.91 11.63c1.77.45 3.11 2.02 3.11 3.94 0 2.25-1.79 4.07-4 4.07a3.86 3.86 0 0 1-2.9-.81" /><path d="M4 15.57c0-2.25 1.79-4.07 4-4.07 1.67 0 3.32 1.3 4 2.5" /></svg>,
    [TRAVEL_STYLES.ADVENTURE]: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m8 3 4 8 5-5 5 15H2L8 3z" /></svg>,
    [TRAVEL_STYLES.CULTURE]: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 22v-8c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v8" /><path d="M5 2c0 3.31 2.69 6 6 6s6-2.69 6-6" /><path d="M5 12V2" /><path d="M19 12V2" /></svg>,
    [TRAVEL_STYLES.FOODIE]: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" /></svg>,
    [TRAVEL_STYLES.LUXURY]: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 3h12l4 6-10 13L2 9z" /></svg>,
};

// Style data using centralized slug definitions
const STYLE_DATA: StyleChip[] = Object.values(TRAVEL_STYLES).map((slug) => ({
    slug,
    labelKey: TRAVEL_STYLE_LABELS[slug],
    icon: STYLE_ICONS[slug],
}));

export { STYLE_DATA };

interface StyleChipsProps {
    selected: string[];
    onChange: (styles: string[]) => void;
}

export function StyleChips({ selected, onChange }: StyleChipsProps) {
    const { t } = useTranslation();

    const toggle = (slug: string) => {
        if (selected.includes(slug)) {
            onChange(selected.filter(s => s !== slug));
        } else {
            onChange([...selected, slug]);
        }
    };

    return (
        <div className="style-chips-row">
            <span className="style-label">{t('tripBuilder.travel_style', 'STIL CĂLĂTORIE:')}</span>
            <div className="style-chips-list">
                {STYLE_DATA.map(style => (
                    <button
                        key={style.slug}
                        type="button"
                        className={`style-chip ${selected.includes(style.slug) ? 'active' : ''}`}
                        onClick={() => toggle(style.slug)}
                    >
                        {style.icon}
                        {t(style.labelKey, style.slug)}
                    </button>
                ))}
            </div>
        </div>
    );
}
